import React from "react";
import { Link } from "react-router-dom";

// styles
import styles from "./styles.module.scss";

// assets
import ArrowLeftIcon from "../../../../assets/images/register/arrow-left.svg";

const Header = ({ title, subTitle, text, icon, handleChange, to }) => {
  return (
    <div className={styles.header}>
      {!icon ? (
        <Link to={to}>
          <span className={styles.skip}>Back</span>
        </Link>
      ) : (
        <img src={ArrowLeftIcon} alt="arrow back" onClick={handleChange} />
      )}
      {title && <h2>{title}</h2>}
      {subTitle && <h3>{subTitle}</h3>}
      {text && <p>{text}</p>}
    </div>
  );
};

export default Header;
